/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 16V22M12 22H8M12 22H16M7 9H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.8909 2H5.1091C4.10448 2 3.60216 2 3.3322 2.20836C3.09716 2.38977 2.95488 2.66624 2.94388 2.96294C2.93124 3.30373 3.2232 3.71248 3.80713 4.52998L12 16L20.1929 4.52998C20.7768 3.71248 21.0688 3.30373 21.0561 2.96294C21.0451 2.66624 20.9028 2.38977 20.6678 2.20836C20.3978 2 19.8955 2 18.8909 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path opacity="0.12" d="M17 9H7L12 16L17 9Z" fill="currentColor" />
			<path
				d="M12.0004 16L20.1932 4.52998C20.7772 3.71248 21.0691 3.30373 21.0565 2.96294C21.0455 2.66624 20.9032 2.38977 20.6682 2.20836C20.3982 2 19.8959 2 18.8913 2H5.10947C4.10484 2 3.60253 2 3.33256 2.20836C3.09752 2.38977 2.95524 2.66624 2.94424 2.96294C2.9316 3.30373 3.22357 3.71248 3.80749 4.52998L12.0004 16ZM12.0004 16L12.0004 22M12.0004 22H8.00036M12.0004 22H16.0004M7.00036 9H17.0004"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.10898 1.25001L5.07396 1.25L5.07396 1.25C4.60157 1.24999 4.19608 1.24997 3.87675 1.27917C3.55925 1.30819 3.18493 1.37453 2.87383 1.61464C2.4625 1.9321 2.21352 2.41593 2.19426 2.93516C2.1797 3.32788 2.34329 3.67103 2.50421 3.94626C2.66607 4.22308 2.90177 4.55304 3.17635 4.93742L3.17635 4.93742L3.1967 4.96592L11.2499 16.2404L11.2499 21.25L7.99987 21.25C7.58566 21.25 7.24987 21.5858 7.24987 22C7.24987 22.4142 7.58566 22.75 7.99987 22.75L11.9999 22.75L15.9999 22.75C16.4141 22.75 16.7499 22.4142 16.7499 22C16.7499 21.5858 16.4141 21.25 15.9999 21.25L12.7499 21.25L12.7499 16.2404L20.803 4.96592L20.8234 4.93747L20.8234 4.93739C21.098 4.55302 21.3337 4.22308 21.4955 3.94626C21.6565 3.67103 21.82 3.32788 21.8055 2.93516C21.7862 2.41593 21.5372 1.9321 21.1259 1.61464C20.8148 1.37453 20.4405 1.30819 20.123 1.27917C19.8037 1.24997 19.3982 1.24999 18.9258 1.25L18.9258 1.25L18.8908 1.25L5.10898 1.25001ZM16.7925 8L19.5824 4.09406C19.8831 3.67316 20.0777 3.39945 20.2006 3.18915C20.2781 3.05672 20.2998 2.99288 20.3054 2.97465C20.299 2.91197 20.2692 2.85399 20.2219 2.81236C20.2038 2.80629 20.1392 2.7869 19.9864 2.77294C19.7438 2.75076 19.408 2.75001 18.8908 2.75001L5.10898 2.75001C4.59173 2.75001 4.25591 2.75076 4.01331 2.77294C3.86053 2.7869 3.79593 2.80629 3.77787 2.81236C3.73058 2.85398 3.70074 2.91197 3.69435 2.97465C3.69991 2.99288 3.72168 3.05671 3.79912 3.18915C3.92208 3.39945 4.11666 3.67316 4.4173 4.09406L7.20726 8L16.7925 8Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14.1429 13L20.1929 4.52998C20.7768 3.71248 21.0688 3.30373 21.0561 2.96294C21.0451 2.66624 20.9028 2.38977 20.6678 2.20836C20.3978 2 19.8955 2 18.8909 2H5.1091C4.10448 2 3.60216 2 3.3322 2.20836C3.09716 2.38977 2.95488 2.66624 2.94388 2.96294C2.93124 3.30373 3.2232 3.71248 3.80713 4.52998L12 16V22M12 22H8M12 22H16M11 9H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 16L20.1929 4.52998C20.7768 3.71248 21.0688 3.30373 21.0561 2.96294C21.0451 2.66624 20.9028 2.38977 20.6678 2.20836C20.3978 2 19.8955 2 18.8909 2H5.1091C4.10448 2 3.60216 2 3.3322 2.20836C3.09716 2.38977 2.95488 2.66624 2.94388 2.96294C2.93124 3.30373 3.2232 3.71248 3.80713 4.52998L12 16ZM12 16V22M12 22H8M12 22H16M7 9H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M6.76069 1.25C4.75144 1.25 3.74681 1.25 3.20687 1.66673C2.73679 2.02954 2.45224 2.58249 2.43023 3.17589C2.40496 3.85747 2.98889 4.67497 4.15674 6.30996L5.89962 8.75H18.1001L19.843 6.30996C21.0109 4.67497 21.5948 3.85747 21.5695 3.17589C21.5475 2.58248 21.263 2.02954 20.7929 1.66673C20.2529 1.25 19.2483 1.25 17.2391 1.25L6.76069 1.25Z"
				fill="currentColor"
			/>
			<path
				d="M4.82812 7.25L11.2498 16.2403V21.25H7.9998C7.58559 21.25 7.2498 21.5858 7.2498 22C7.2498 22.4142 7.58559 22.75 7.9998 22.75H15.9998C16.414 22.75 16.7498 22.4142 16.7498 22C16.7498 21.5858 16.414 21.25 15.9998 21.25H12.7498V16.2403L19.1715 7.25L4.82812 7.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
